import React, { useEffect, useState } from 'react';
import { onConnectionChange, isConnected } from '../services/socket';

const ConnectionStatus: React.FC = () => {
  const [connected, setConnected] = useState(isConnected());
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const unsub = onConnectionChange((status) => {
      setConnected(status);
      if (!status) {
        setShowBanner(true);
      } else {
        // Скрываем баннер через секунду после восстановления
        setTimeout(() => setShowBanner(false), 1500);
      }
    });
    return unsub;
  }, []);

  if (!showBanner) return null;

  return (
    <div className={`fixed top-0 left-0 right-0 z-[200] text-center py-1.5 text-xs font-medium transition-colors duration-300 ${
      connected
        ? 'bg-green-500 text-white'
        : 'bg-yellow-400 text-yellow-900'
    }`}>
      {connected ? 'Подключение восстановлено' : 'Переподключение...'}
    </div>
  );
};

export default ConnectionStatus;
